import ReactDOM from 'react-dom/client';
import App from './app/App';

const el = document.querySelector('#mcfly-glossary');

if (el) {
	const root = ReactDOM.createRoot(el);

	root.render(<App dataUrl={el.getAttribute('data-rest-url')} />);
}
